<template>
  <router-view />
</template>

<script>

export default {
  computed: {
    country: {
      get() {
        return this.$globalVar.countries.find(
          (c) => c.value == this.$store.state.country
        );
      },
      set(newValue) {
        this.$store.commit("setCountry", newValue);
      },
    },
    localeLang: {
      get() {
        return this.$globalVar.locales.find(
          (c) => c == this.$store.state.lang
        );
      },
      set(newValue) {
        this.$store.commit("setLocaleLang", newValue);
      },
    },
  },

  mounted() {
    if(!this.country) {
      const cont = this.$globalVar.countries.find(
        (c) => c.iso2 == location.origin.split('.').pop()
      );

      if(cont) {
        this.country = cont.value;
      }
    }

    var pathLocale = location.pathname.split('/')[1];

    if(pathLocale.length > 2) {
      pathLocale = 'nl';
    }

    if(!this.localeLang || ((this.localeLang != pathLocale))) {
      const loc = this.$globalVar.locales.find(
        (c) => c == location.pathname.split('/')[1]
      );

      this.localeLang = loc ?? 'nl';
    }
  }
};
</script>

<style lang="scss">
// Import Main styles for this application
@import 'styles/style';
</style>
